import { usePrivy } from '@privy-io/react-auth'
import { useAccount } from 'wagmi'
import { useEffect, useRef } from 'react'
import { identifyUser, resetUser } from './identify'
import { track } from './events'

export function useWalletIdentify(): void {
  const { authenticated, user } = usePrivy()
  const { address, connector, chainId } = useAccount()
  const wasAuthenticatedRef = useRef<boolean | null>(null)

  useEffect(() => {
    if (authenticated && user?.id && address) {
      // Only fire wallet_connect_completed on actual connection transition, not page refresh
      if (wasAuthenticatedRef.current === false) {
        track('wallet_connect_completed', {
          wallet_type: connector?.name ?? 'unknown',
          chain_id: chainId ?? 0,
        })
      }
      // Always re-identify (idempotent)
      identifyUser({
        privy_user_id: user.id,
        wallet_address: address,
        wallet_type: connector?.name ?? 'unknown',
        chain_id: chainId ?? 0,
      })
    } else if (wasAuthenticatedRef.current === true && !authenticated) {
      resetUser()
    }

    wasAuthenticatedRef.current = authenticated
  }, [authenticated, user?.id, address, connector?.name, chainId])
}
